import { useEffect, useState } from 'react';
import { api } from '../../services/api';
import type { PublicMasterProfile } from '../../types/auth';
import { retryAsync } from '../../utils/retry';

/** Public profiles include viewer-specific subscription state. */
export function useHomeMasterProfiles(ownerKey: string | null) {
  const [snapshot, setSnapshot] = useState<{
    ownerKey: string | null;
    masters: PublicMasterProfile[] | null;
  }>({ ownerKey: null, masters: null });

  useEffect(() => {
    if (ownerKey === null) return;
    let alive = true;
    retryAsync(() => api.getPublicMasterProfiles({ sort: 'ranked' }), {
      retries: 2, baseDelayMs: 400,
    })
      .then((masters) => { if (alive) setSnapshot({ ownerKey, masters }); })
      .catch(() => { if (alive) setSnapshot({ ownerKey, masters: [] }); });
    return () => { alive = false; };
  }, [ownerKey]);

  // Do not expose the previous viewer's flags while the next request is loading.
  const masters = ownerKey !== null && snapshot.ownerKey === ownerKey ? snapshot.masters : null;
  return { masters, ready: masters !== null };
}
